export default {
  //首页钢材
  seriaserialNoWidthlNo: 90, // 序号
  titleWidth: 380, //标题
  //详情
  equipmentDescWidth: 250, //设备物资说明
  operationWidth: 100 //操作
};
